import { LOCAL_EXECUTION } from './utils/featureFlag'

export const NOT_ALLOWED = 'Você não permissão para este recurso'
export const BAD_REQUEST = 'Houve um erro no servidor, faça login novamente'
export const JWT_EXPIRED = 'Autenticação expirada, você será redirecionado'
export const PAINEL_URL = (
  process.env.REACT_APP_STAGE === 'prd'
    ? process.env.REACT_APP_P2_MAIN_URL_PROD
    : process.env.REACT_APP_STAGE === 'stg'
    ? process.env.REACT_APP_P2_MAIN_URL_STG
    : process.env.REACT_APP_P2_MAIN_URL_DEV
) as string

export const SSO_URL = process.env.REACT_APP_SSO_URL as string
export const ALL_DAYS_DATE = '2020-01-01'
export const DATADOG_STAGE = process.env.DATADOG_STAGE ?? 'dev'
export const STORAGE_PREFIX = 'producer-dashboard-app-'
export const ENABLE_NEW_TED_MODAL =
  process.env.REACT_APP_ENABLE_NEW_TED_MODAL === 'true'
export const DOMAIN_NAME = LOCAL_EXECUTION
  ? 'dashboard-produtor-dev.bilheteriadigital.net'
  : process.env.REACT_APP_DOMAIN_NAME
